/**
 * @file index.tsx
 *
 * @fileoverview Renders the Site campaign above header.
 */

import React from 'react';
import Link from '~/jobiqo/components/Link';
import { Box } from '~/vcl/atoms/07-box';
import { Text } from '~/vcl/atoms/13-text/03-text';
import GET_SITE_CAMPAIGN from '~/jobiqo/components/Header/graphql/getSiteCampaign.gql';
import { useQuery } from '@apollo/client';

function shouldDisplayCampaign(
  path: string,
  body: string,
  whiteList: string[],
  blackList: string[],
): boolean {
  if (body.length <= 0) {
    return false;
  } else if (whiteList.length > 0) {
    return whiteList.includes(path);
  } else if (blackList.length > 0) {
    return !blackList.includes(path);
  }
  return true;
}

interface SiteCampaignProps {
  path: string;
}
export default function SiteCampaign({ path }: SiteCampaignProps) {
  const { data } = useQuery(GET_SITE_CAMPAIGN);

  if (!data || data.getSiteCampaign.error) {
    return null;
  }

  return (
    shouldDisplayCampaign(
      path,
      data.getSiteCampaign.body,
      data.getSiteCampaign.whiteList,
      data.getSiteCampaign.blackList,
    ) &&
    (data.getSiteCampaign.url ? (
      <Link href={data.getSiteCampaign.url}>
        <Box
          backgroundColorOverride={`var(--color-${data.getSiteCampaign.backgroundColor})`}
          marginClean={true}
          padding={3}
          data-test-id="site-campaign"
          borderRadius="0"
        >
          <Text
            color={data.getSiteCampaign.textColor}
            textAlign="center"
            margin="5"
          >
            {data.getSiteCampaign.body}
          </Text>
        </Box>
      </Link>
    ) : (
      <Box
        backgroundColor="primary"
        marginClean={true}
        padding={3}
        data-test-id="site-campaign"
        borderRadius="0"
      >
        <Text color="white" textAlign="center" margin="5">
          {data.getSiteCampaign.body}
        </Text>
      </Box>
    ))
  );
}
